<template>
  <div>
    <div class="stylist">
      <div class="box">
        <el-carousel trigger="click" :height="isPC?'328px':'390px'">
          <el-carousel-item v-for="(item, i) in user" :key="i">
            <div class="box1 f-b-c">
              <div class="left f--c">
                <div class="img" @click="playMpbileVideo(i)">
                  <div class="play f-c-c">
                    <i class="el-icon-caret-right"></i>
                  </div>
                  <oss-img :width="200" :height="200" :src="item.avatar" />
                </div>
                <div>
                  <div class="title1">{{ $t(item.name) }}</div>
                  <div class="sub">{{ $t(item.sub) }}</div>
                </div>
              </div>
              <div class="right">
                <div class="r-left">
                  <oss-img :width="66" :height="53" src="https://img.kakaclo.com/web-img/home/customize/icon_img1.png" />
                </div>
                <div class="r-right">
                  <oss-img :width="66" :height="53" src="https://img.kakaclo.com/web-img/home/customize/icon_img2.png" />
                </div>
                {{ $t(item.text) }}
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div v-if="showMpbileVideo" style="width: 100%; height: 100%; background-color: #212326; position: fixed; left: 0; top: 0; z-index: 2011">
      <el-dialog :visible.sync="showMpbileVideo" class="mpbile-dialog" width="100%">
        <video style="width: 100%" autoplay="autoplay" muted="false" loop controls>
          <source :src="videoMpbileUrl" type="video/mp4" />
        </video>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: [
        {
          name: 'Home.Dropshipping.Thomas',
          sub: 'Home.Dropshipping.CEOFounder',
          text: 'Home.Dropshipping.Tips40',
          avatar: 'https://img.kakaclo.com/web-img/home/video/img/1.png'
        },
        {
          name: 'Home.Dropshipping.Tamara',
          sub: 'Home.Dropshipping.CEOFounderAtIClosam',
          text: 'Home.Dropshipping.Tips41',
          avatar: 'https://img.kakaclo.com/web-img/home/video/img/2.png'
        },
        {
          name: 'Home.Dropshipping.Mike',
          sub: 'Home.Dropshipping.CEOFounderAtHalton',
          text: 'Home.Dropshipping.Tips42',
          avatar: 'https://img.kakaclo.com/web-img/home/video/img/3.png'
        },
        {
          name: 'Home.Dropshipping.James',
          sub: 'Home.Dropshipping.CEOFounderAtNewErie',
          text: 'Home.Dropshipping.Tips43',
          avatar: 'https://img.kakaclo.com/web-img/home/video/img/4.png'
        },
        {
          name: 'Home.Dropshipping.Diana',
          sub: 'Home.Dropshipping.CEOFounder',
          text: 'Home.Dropshipping.Tips44',
          avatar: 'https://img.kakaclo.com/web-img/home/video/img/5.png'
        },
        {
          name: 'Home.Dropshipping.TeArra',
          sub: 'Home.Dropshipping.CEOFounder',
          text: 'Home.Dropshipping.Tips45',
          avatar: 'https://img.kakaclo.com/web-img/home/video/img/6.png'
        }
      ],
      showMpbileVideo: false
    }
  },
  methods: {
    playMpbileVideo(i) {
      this.videoMpbileUrl = `https://img.kakaclo.com/web-img/home/video/video/${i + 1}.mp4`
      this.showMpbileVideo = true
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
}
.stylist {
  padding: 104px 0;
  background-image: url('https://img.kakaclo.com/web-img/home/customize/bg_img4.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .box {
    max-width: 1420px;
    margin: 0 auto;
    padding: 0 20px;
    background-color: #fff;
    border-radius: 12px;
    .sub {
      font-size: 16px;
      line-height: 24px;
      color: #606266;
      margin: 0 auto;
    }
    .box1 {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding: 0 140px 0 100px;
      .img {
        width: 200px;
        height: 200px;
        border-radius: 50%;
        margin-right: 26px;
        position: relative;
        cursor: pointer;
        .play {
          width: 54px;
          height: 54px;
          background: rgba(255, 255, 255, .7);
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          margin: auto;
          border-radius: 50%;
          .el-icon-caret-right {
            font-size: 36px;
          }
        }
        img {
          border-radius: 50%;
        }
      }
      .title1 {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 8px;
      }
      .sub {
        color: #909399;
      }
      .right {
        width: 55%;
        font-size: 24px;
        font-weight: bold;
        line-height: 32px;
        position: relative;
        .r-left,.r-right {
          width: 66px;
          height: 53px;
          position: absolute;
          top: -34px;
          left: -60px;
        }
        .r-right {
          top: unset;
          left: unset;
          bottom: -34px;
          right: -60px;
        }
      }
    }
  }
  @media screen and (max-width: 1000px) {
    padding: 48px 16px;
    .box {
      padding: 28px 4px;
      .box1 {
        padding: 0;
        flex-direction: column;
        justify-content: flex-start;
        .left {
          flex-direction: column;
          justify-content: center;
          .img {
            width: 86px;
            height: 86px;
            margin: 0 0 8px 0;
            .play {
              width: 32px;
              height: 32px;
            }
          }
          .title1,.sub {
            font-size: 12px;
            line-height: 18px;
            text-align: center;
          }
          .title1 {
            margin-bottom: 4px;
          }
        }
        .right {
          padding: 0;
          margin-top: 40px;
          width: 80%;
          .r-left {
            top: -52px;
            left: -20px;
          }
          .r-right {
            top: unset;
            left: unset;
            bottom: -52px;
            right: -20px;
          }
        }
      }
    }
  }
}
</style>
